import { render, staticRenderFns } from "./SpinnerIcon.vue?vue&type=template&id=4a081624&scoped=true"
var script = {}
import style0 from "./SpinnerIcon.vue?vue&type=style&index=0&id=4a081624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a081624",
  null
  
)

export default component.exports